export default __webpack_public_path__ + "static/media/25.20494d8a.png";